import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  Modal as AntModal,
  ModalFooter,
} from 'reactstrap'
import { IoIosCloseCircle } from 'react-icons/io'
import { AiOutlineSave } from 'react-icons/ai'

import { PayoutDetail } from './payout-detail'
import { PartialDetail } from './partial-detail'
import { Button } from '../../../../buttons'
import { FONTS } from '../../../../../constants'

export const EditAPPaying = ({ isEdit, data, handleClose, editPaying }) => {
  const [detailState, setDetailState] = useState({ partials: [], remark: '' })

  useEffect(() => {
    if (data) {
      let partials = []
      if (data.hardware_id) {
        partials = data.accountant_paying_hardwares ?
          data.accountant_paying_hardwares.find(h => h.hardware_id === data.hardware_id) : null
      } else if (data.license_id) {
        partials = data.accountant_paying_licenses ?
          data.accountant_paying_licenses.find(l => l.license_id === data.license_id) : null
      } else {
        partials = data.accountant_paying_vendors ?
          data.accountant_paying_vendors.find(v => v.vendor_id === data.vendor_id) : null
      }
      const remark = partials ? partials.remark : ''
      partials = partials ? partials.partials : [
        {
          period_no: '1',
          description: data.description,
          cost: data.cost.toString(),
          delivery_date: data.delivery_date,
          credit_term: data.credit_term,
          status: 'UNPAID',
        },
      ]
      setDetailState({ partials, remark })
    }
  }, [data])

  const handleInput = (e, name, idx) => {
    if (name === 'add') {
      const partials = [
        ...detailState.partials, {
          period_no: (detailState.partials.length + 1).toString(),
          description: '',
          delivery_date: '',
          credit_term: '',
          cost: '0',
          status: 'UNPAID',
        }]
      setDetailState({ ...detailState, partials })
    } else if (name === 'remove') {
      let partials = [...detailState.partials]
      partials.splice(e, 1)
      partials = partials.map((p, idx) => { return { ...p, period_no: (idx + 1).toString() } })
      setDetailState({ ...detailState, partials })
    } else if (name === 'remark') {
      setDetailState({ ...detailState, remark: e })
    } else {
      const _detailState = { ...detailState }
      const partial = { ...detailState.partials[idx] }
      partial[name] = e
      _detailState.partials[idx] = partial
      setDetailState({ ...detailState })
    }
  }

  const handleSave = async () => {
    if (data.hardware_id) {
      await editPaying('hardware_id', data, detailState)
    } else if (data.license_id) {
      await editPaying('license_id', data, detailState)
    } else {
      await editPaying('vendor_id', data, detailState)
    }
    resetState()
  }

  const resetState = () => {
    setDetailState({ partials: [], remark: '' })
  }

  return (
    <Modal
      size='lg'
      isOpen={ isEdit }
      toggle={ handleClose }
    >
      <ModalHeader toggle={ handleClose }>
        <HeaderText>AP Paying Detail</HeaderText>
        <AlignCenterWrapper>
          <IoIosCloseCircle onClick={ handleClose } />
        </AlignCenterWrapper>
      </ModalHeader>

      <BodyWrapper>
        <PayoutDetail
          data={ data }
          detailState={ detailState }
        />
        <PartialDetail
          detailState={ detailState }
          handleInput={ handleInput }
        />
      </BodyWrapper>

      <ModalFooter>
        <ButtonGroup>
          <Button
            theme='#28a745'
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ handleSave }
          >
              Save
          </Button>
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ handleClose }
          >
              Cancel
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  )
}

const Modal = styled(AntModal)`
  .modal-header {
    border: none;
  }

  .modal-footer {
    border: none;
    background: #F9F9F9;
  }
`

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 16px 0 16px;

  svg {
      font-size: 24px;
      color: #C4C4C4;
      cursor: pointer;
  }
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
`

const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 500px;
  overflow-y: scroll;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  padding: 28px 16px 0 16px;
`

const Row = styled.div`
  display: flex;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;

  div:nth-child(1) {
    margin-right: 12px;
  }
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ap-paying/edit-ap-paying/index.js